import gql from "graphql-tag";

export const OC_GET_CUSTOMER_LICENCES = gql`
  query getCustomerLicences {
    getCustomerLicences {
      userAzon
      ocLicences {
        company
        myHR
        myHRChangeData
        myHRSaveTaxApplications
        myLeave
        myLeaveEmployeeRequests
        myCafeteria
        myTime
        myTimeEmployeeRequests
        myDocuments
        mySheet
        myNewsFeed
      }
    }
  }
`;
